import { Card, Switch, Text, Title } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../../styles/AdminToolsPage.css';
import {
  getAdminToolsConfig,
  subscribeAdminToolsConfig,
  updateAdminToolsConfig,
  type AdminToolsConfig,
} from '../../state/adminToolsStore';

export const AdminToolsPage: React.FC = () => {
  const { t } = useTranslation('common');
  const [config, setConfig] = useState<AdminToolsConfig>(() => getAdminToolsConfig());

  useEffect(() => {
    return subscribeAdminToolsConfig(setConfig);
  }, []);

  return (
    <div className="admin-tools-page">
      <div className="admin-tools-header">
        <Title order={2} className="admin-tools-title">
          {t('admin.tools.title')}
        </Title>
        <Text className="admin-tools-subtitle">{t('admin.tools.subtitle')}</Text>
      </div>

      <Card shadow="md" radius="md" className="admin-tools-card">
        <div className="admin-tool-row">
          <div className="admin-tool-copy">
            <Title order={4} className="admin-tool-name">
              {t('admin.tools.hoverCoordinates.title')}
            </Title>
            <Text className="admin-tool-description">
              {t('admin.tools.hoverCoordinates.description')}
            </Text>
          </div>
          <Switch
            checked={config.showHoverCoordinates}
            onChange={(event) =>
              updateAdminToolsConfig({ showHoverCoordinates: event.currentTarget.checked })
            }
            size="lg"
            aria-label={t('admin.tools.hoverCoordinates.aria')}
            className="admin-tool-switch"
          />
        </div>
      </Card>
    </div>
  );
};
